import {
    GET_MERCHANT_PERMISSION_SUCCESS,
    GET_MERCHANT_SUBMERCHANTID_SUCCESS,
    GET_MERCHANT_PERMISSION_BYMERCHANTID_SUCCESS,
    MERCHANT_PERMISSION_API_ERROR
} from "./actionTypes"

const INIT_STATE = {
    record: {}, //Model Data ve Error
    error: {},
    subMerchantId: "",
}

const merchantPermission = (state = INIT_STATE, action) => {
    switch (action.type) {

        case GET_MERCHANT_PERMISSION_SUCCESS:
            return {
                ...state,
                record: action.payload,
            }
        case GET_MERCHANT_SUBMERCHANTID_SUCCESS:
            return {
                ...state,
                subMerchantId: action.payload,
            }
        case GET_MERCHANT_PERMISSION_BYMERCHANTID_SUCCESS:
            return {
                ...state,
                record: action.payload,
            }

        case MERCHANT_PERMISSION_API_ERROR:
            return {
                ...state,
                error: action.payload,
            }

        default:
            return state
    }
}

export default merchantPermission